function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeBlack = function SvgYoutubeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m12.643 55.4 5.856.72a140.682 140.682 0 0 0 33.062-.031l5.792-.689a9.439 9.439 0 0 0 8.078-7.17 55.791 55.791 0 0 0 .062-26.018L65.4 21.8a9.443 9.443 0 0 0-8.078-7.2l-5.761-.689a139.035 139.035 0 0 0-33.062 0l-5.793.689A9.478 9.478 0 0 0 4.6 21.8l-.094.407A55.8 55.8 0 0 0 3 35.076a56.52 56.52 0 0 0 1.566 13.15 9.479 9.479 0 0 0 8.077 7.174Zm16.281-28.912a.678.678 0 0 1 1.033-.579l13.925 8.525a.678.678 0 0 1 0 1.158l-13.925 8.5a.679.679 0 0 1-1.032-.579Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgYoutubeBlack;